// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rabsca: PokeData = {
  "id": 954,
  "name": "rabsca",
  "height": 3,
  "weight": 35,
  "base_experience": 165,
  "types": [
    PokeType.BUG,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "psybeam",
    "confusion",
    "psychic",
    "defense-curl",
    "rollout",
    "extrasensory",
    "power-swap",
    "guard-swap",
    "bug-buzz",
    "bug-bite",
    "struggle-bug",
    "lunge",
    "speed-swap",
    "revival-blessing"
  ],
  "moves": [
    "tackle",
    "psychic",
    "bug-buzz",
    "bug-bite",
    "lunge",
    "calm-mind",
    "pin-rush",
    "pounce",
    "string-shot",
    "heal-order",
    "signal-spam",
    "reflect",
    "pin-missile"
  ],
  "evolution_chain": {
    "id": 499,
    "item": null,
    "species": [
      {
        "name": "rellor",
        "order": 922,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rabsca",
        "order": 923,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 953,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 137,
    "speed": 74,
    "ability_power": 189
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
